import { render, staticRenderFns } from "./messageview.vue?vue&type=template&id=22b07d9e&"
import script from "./messageview.vue?vue&type=script&lang=ts&"
export * from "./messageview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports